import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-responses',
  imports: [],
  templateUrl: './contact-responses.component.html',
  styleUrl: './contact-responses.component.css',
})
export class ContactResponsesComponent {

}
